import { Control, UseFormRegister, useFormState } from 'react-hook-form';
import React from 'react';
import { InputField } from '../input/InputField';

type Props = {
    register: UseFormRegister<any>;
    control: Control<any, object>;
};

export const ParentPersonalInformationFields: React.FC<Props> = ({ register, control }) => {
    const { errors } = useFormState({ control });
    return (
        <>
            <InputField
                error={(errors.first_name as any)?.message}
                htmlFor={'first_name'}
                label="First Name"
                placeholder="First Name"
                required={true}
                register={register}
            />
            <InputField
                error={(errors.last_name as any)?.message}
                htmlFor={'last_name'}
                label="Last Name"
                placeholder="Last Name"
                required={true}
                register={register}
            />
            <InputField
                error={(errors.phone as any)?.message}
                htmlFor={'phone'}
                label="Phone"
                placeholder="Phone"
                required={true}
                register={register}
            />
        </>
    );
};
